import styled from 'styled-components'
import { Grid, Typography } from '@material-ui/core'
import { Icon } from '../icon/icon'

export const StyledTitleChevron = styled(Icon) <{ $rotate?: boolean }>`
  position: absolute;
  top: ${props => props.theme.typography.pxToRem(2)};
  right: -${props => props.theme.typography.pxToRem(20)};
  color: currentColor;
  margin-top: ${props => props.theme.typography.pxToRem(4)};
  font-size: ${props => props.theme.typography.pxToRem(16)};
  transition: all 0.2s ease;
  opacity: 0;
`

export const StyledTitleText = styled(Typography)`
  color:  ${props => props.theme.palette.secondary.dark};
  font-size: ${props => props.theme.typography.pxToRem(20)};
  font-weight: 600;
  transition: color 0.2s ease;
  position: relative;

  ${props => props.theme.breakpoints.up('sm')} {
    margin-left: 0;
  }

  &:hover {
    color: ${props => props.theme.palette.secondary.dark};

    ${StyledTitleChevron} {
      opacity: 1;
    }
  }
`

export const StyledTitleLinksWrapper = styled(Grid)`
  > a {
    text-decoration: none;
  }
`

export const StyledCardIconContainer = styled(Grid)`
  margin-bottom: ${props => props.theme.typography.pxToRem(26)};
`

export const StyledCardList = styled(Grid)`
  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => props.theme.typography.pxToRem(30)};
  }
`

export const StyledNavDropdownLinksContainer = styled(Grid)`
  > div:not(:last-child) {
    padding-left: ${props => props.theme.typography.pxToRem(20)};
    padding-right: ${props => props.theme.typography.pxToRem(20)};
  }
`